import { Button, Form, Input, Select, Spin, Table } from "antd";
import { observer } from "mobx-react";
import React from "react";
import { defaultFormLayout } from "../../common/Utils";
import { familyStore } from "../../store/family/FamilyStore";

export const FamilyAddExistingChild = observer(({ onAdd }) => {
  const [form] = Form.useForm();
  const { addChild } = familyStore;

  const onSearch = () => {
    form.validateFields().then((values) => {
      console.log("values", values);
      addChild.existingStore.search(values);
    });
  };

  const columns = [
    { title: "Full Name", dataIndex: "name" },
    { title: "email", dataIndex: "email" },
    {
      title: "",
      render: (_, r) => <Button onClick={() => onAdd(r.id)}>Add Child</Button>,
    },
  ];

  return (
    <>
      <Form form={form} {...defaultFormLayout} initialValues={{}}>
        <Form.Item name="schoolId" label="School" rules={[{ required: true, message: "Please select school" }]}>
          <Select
            style={{ width: "100%" }}
            placeholder="Enter school name to search"
            showSearch
            filterOption={false}
            onSearch={(val) => addChild.setKeyword(val)}
            onChange={(val) => addChild.existingStore.onSchool(val)}
            notFoundContent={
              addChild.loadingSchool ? (
                <Spin size="small" />
              ) : addChild.keyword.trim() ? (
                "No data."
              ) : (
                "Enter school name to search."
              )
            }
          >
            {addChild.orgs.map((p: any) => (
              <Select.Option key={p.id} value={p.id}>
                {p.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Grade" shouldUpdate required>
          {() => {
            return (
              <Form.Item name="grade" noStyle rules={[{ required: true, message: "Please input grade" }]}>
                <Select style={{ width: "100%" }} placeholder="Please select">
                  {addChild.existingStore.grades.map((p) => (
                    <Select.Option key={p} value={p}>
                      {p}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item label="First Name" name="firstName">
          <Input maxLength={50} placeholder="Enter first name" />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 16, offset: 8 }}>
          <Button danger onClick={onSearch}>
            Search
          </Button>
        </Form.Item>
      </Form>
      <Table
        size="small"
        loading={addChild.existingStore.loading}
        rowKey="id"
        columns={columns}
        dataSource={addChild.existingStore.children}
      />
    </>
  );
});
